<style>
  .clearfix:after {
    content: '';
    display: block;
    visibility: hidden;
    clear: both;
  }
  .select-container {
    padding: 15px 2% 3px;
  }
  .select-left {
    float: left;
    display: table;
  }
  .select-left > div {
    vertical-align: top;
  }
  .select-left > div:not(:last-child) {
    margin-right: 5px;
  }
  .select-right {
    float: right;
  }
</style>

<template>
  <div>
    <div class="select-container clearfix" style="margin-top: 2%;margin-left: 2%;float: left;">
    <span style="font-size:38px;font-weight:bold;">macOS FAQ</span><br><br><br>
    <span style="font-size:30px;font-weight:bold;">1. 已安装了MOA但是后台提示未安装</span><br><br>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic01.png" width=740px height=400px></p>
    <p>原因：MOA安装后需要使用大象扫码登录后才算完全安装完毕。</p>
    <p><strong>解决方法：请打开MOA客户端，使用大象扫码登陆。</strong></p>
    <p><span style="font-size:30px;font-weight:bold;">2. macOS操作系统安装MOA时提示“打不开MOA安装包，因为它来自身份不明的开发者”</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic02.png" width=640px height=320px></p>
    <p><strong>解决方法：在“系统偏好设置“-->”“安全性与隐私”-->"通用" 中找到阻止MOA打开的选项， 选择“仍然打开”。</strong></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic03.png" width=540px height=400px></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic04.png" width=450px height=400px></p>
    <p><span style="font-size:30px;font-weight:bold;">3. 应用打开页面空白</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic05.png" width=650px height=400px></p>
    <p><strong>解决方法：</strong></p>
    <p><strong>a、检查电脑的网络状况，待网络畅通后点击右上角“刷新页面”按钮刷新。</strong></p>
    <p><strong>b、确认使用的MOA版本，使用最新稳定版MOA。（移步IT门户，确认或下载最新版MOA
    <a data-auto_update="0" data-pageid="" href="https://itportal.sankuai.com/" style="color:#1890ff" class="ct-link" target="_blank" rel="noopener">https://itportal.sankuai.com/</a>）
    </strong></p>
    <p><span style="font-size:30px;font-weight:bold;">4.电脑网络正常但软件的客户端界面显示离线</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic06.png" width=750px height=400px></p>
    <p><strong>解决方法：显示客户端离线是指软件与后台服务器的连接失败。此情况常见于电脑断网后的几分钟，软件会在十分钟之内重连服务器。</strong></p>
    <p><span style="font-size:30px;font-weight:bold;">5.运行后“界面显示异常或空白”</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic07.jpg" width=650px height=400px></p>
    <p>原因：macOS 10.10版本的bug，不影响软件使用和统计，MOA新版本已修复。</p>
    <p><strong>解决方法：</strong></p>
    <p><strong>a.检查MOA是否最新版本，升级到最新版本；</strong></p>
    <p><strong>b.联系信息安全中心 ganlubing,zhaoliyang02。</strong></p>
    <p><span style="font-size:30px;font-weight:bold;">6.首页网络接入处显示“无网络”</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic08.png" width=750px height=400px></p>
    <p>原因：macOS10.10的显示bug，不影响其他功能，可以忽略。显示在线就代表正常了，MOA新版本已修复。</p>
    <p><span style="font-size:30px;font-weight:bold;">7.阻断策略开启后，提示证书安装失败，需要手动输入密码</span></p>
    <p><strong>解决办法：</strong></p>
    <p>a、打开“钥匙串访问”app，打开方式：“启动台”-->“其他“-->”钥匙串访问“。</p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic10.png" width=280px height=220px></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic11.png" width=600px height=220px></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic12.png" width=600px height=300px></p>
    <p>b、选择菜单栏，“文件”-->"锁定钥匙串'登陆'“。</p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic13.png" width=580px height=350px></p>
    <p>c、选择菜单栏，“文件” -->“解锁钥匙串'登陆'"。</p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic14.png" width=500px height=390px></p>
    <p><span style="font-size:30px;font-weight:bold;">8.阻断策略开启后，无法登录SSO</span></p>
    <p>打开系统“钥匙串访问”，搜索local，如图所示，查看证书“<strong>localhost.moa.sankuai.com</strong>”（下图红框标示）是否存在，</p>
    <p>若不存在，参考「9」中解决办法。</p>
    <p>若存在进一步抓取日记：切换到 ~/Library/Logs/itsec-agent/目录下。打开日期最近的一次日志，在日志中搜索"SSLIdentityAndCertificates: Creating New Identity"，如果搜索到关键字，</p>
    <p>解决方法参考「7」，如果没有，联系RD （信息安全中心：ganlubing,zhaoliyang02）</p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic15.png" width=850px height=500px></p>
    <p><span style="font-size:30px;font-weight:bold;">9.阻断策略开启后，提示需要输入<span style="color:red">本地管理员</span>密码弹框</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic16.png" width=330px height=150px></p>
    <p><strong>解决方法：</strong></p>
    <p><strong>1、需要输入的是<span style="color:red">本地管理员密码</span>。</span></strong></p>
    <p><strong>2、如果出现这种弹框，选择“始终允许”。</strong></p>
    <p><span style="font-size:30px;font-weight:bold;">10.安装MOA后无法打开</span></p>
    <p>如果MOA安装后无法打开，需确认macOS的操作系统版本，MOA的支持macOS版本为 >=10.11。如果您的操作系统是10.11,您需要安装最新版本的MOA，并<strong>重启</strong>您的操作系统。</p>
    <p><strong>点击左上角苹果图标，查看「关于本机」显示操作系统版本</strong></p>
    <p>如果操作系统版本满足要求，还有问题，联系RD（信息安全中心：ganlubing,zhaoliyang02）</p>
    <p><span style="font-size:30px;font-weight:bold;">11、查看MOA版本</span></p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic17.png" width=1000px height=600px></p>
    <p><span style="font-size:30px;font-weight:bold;">12、MOA扫码后账户显示“unknow”</span></p>
    <p>旧版本MOA未彻底卸载，MOA新版本运行异常。</p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic18.png" width=200px height=200px></p>
    <p>请在终端中执行：rm -rf /Applications/MOA.app ，删除掉旧版本MOA残留文件后，重新安装最新版MOA，即可扫码成功。</p>
    <p><img src="../assets/macOS_FAQ/macOS_FAQ_pic19.png" width=900px height=150px></p>
    <p><span style="font-size:30px;font-weight:bold;">13、MOA已经是最新版本，仍然跳出拦截。</span></p>
    <p>旧版本MOA未彻底卸载，MOA新版本运行异常。</p>
    <p>解决方法：请在终端中执行： rm -rf /Applications/MOA.app 后，删除掉旧版本MOA残留文件后，重新安装最新版MOA。</p>

    </div>
  </div>
</template>

<script>
  import store from '../vuex/service/store'
  import axios from 'axios'
  import {mapState} from 'vuex';
  import util from '../views/util/commonUtil'

  export default {
    store: store,
    mounted: function () {
      var vm =this;
      if(vm.token == ""){
        var token = this.getCookie("access-token");
        if(token != null){
          vm.$store.commit('UPDATETOKEN',token);
          vm.token = token;
        }
      }
      vm.getUser();
    },
    computed: mapState({
      loginRediret: function (state) {
        return state.loginRediret;
      },
      cookieName: function (state) {
        return state.cookieName;
      },
      getuserAPI: function (state) {
        return state.getuserAPI;
      }
    }),
    filters: {
      idcExplain(val) {
        return util.idcExplain(val)
      },
      timeFormat(val) {
        return util.timeFormat(val)
      },
      switchColor(val) {
        return util.switchColor(val)
      },
      statusExplain(val) {
        return util.statusExplain(val)
      }
    },
    methods: {
      reset() {

      },
      kmUrl(URL){
        window.open(URL);
      },
      routerUrl(URL){
        this.$router.push(URL)
      },
      handleSelectionChange(val) {
        this.multipleSelection = val;
      },
      getCookie(name){
        var arr,reg=new RegExp("(^| )"+name+"=([^;]*)(;|$)");
        if(arr=document.cookie.match(reg))
          return unescape(arr[2]);
        else
          return null;
      },
      getUser() {
        var vm = this;
        if (vm.user == null || vm.user == "") {
          vm.user = vm.getCookie("username");
          document.cookie="ssoid="+vm.getCookie("access-token");
          axios.get(vm.getuserAPI, {
            withCredentials: true
          }).then((response) => {
            if(response.data.status==401){
               document.cookie = vm.cookieName + vm.$route.fullPath;
               window.location = vm.loginRediret;
            }

          }).catch(function (error) {
            vm.requesterrorinfo(error)
          })
        }
      },
      requesterrorinfo(error){
        var vm =this;
        if (error.response) {
          var code = error.response.status;
          if (code == 401) {
            vm.$message.error("401:您未登录");
            var count = vm.getCookie("access-count")
            window.location = vm.loginRediret;
            if(count==null || count==0){
              document.cookie="access-count=1";
              vm.$message('您未登录,请刷新');
              document.cookie = vm.cookieName + vm.$route.fullPath;
              window.location = vm.loginRediret;
            }else{
              vm.$message('您未登录,请刷新');
            }
          } else {
            if (code == 404) {
              vm.$notify({
                title: '提示',
                message: '404:Not found!',
                type: 'error'
              });
            } else {
              vm.$notify({
                title: '提示',
                message: '501:服务端未响应!',
                type: 'error'
              });
            }
          }
        } else {
          vm.$notify({
            title: '提示',
            message: '502:服务端未响应!',
            type: 'error'

          });
        }
      }
    },
    data() {
      return {
        hostname:'',
        token:'',
      }
    }
  }
</script>
<style>
  .select1 {
    width: 100px;
  }
  .select2 {
    width: 130px;
  }
  .select3 {
    width: 160px;
  }
  .input1 {
    width: 350px;
  }
  .input2 {
    width: 210px;
  }
  .demo-table-expand label {
    width: 140px;
    color: #5d94bf;
  }
</style>



// WEBPACK FOOTER //
// macOS_FAQ.vue?c32a3728